import { createSlice } from '@reduxjs/toolkit';

const initialStateValue =  [
  { 
    id : 1,
    to : 'about', 
    title: '회사소개', 
    subTitles : [
      {
        subId : '1',
        subTo : 'about/overview',
        subTitle : '소개 및 주요사업',
      },
      {
        subId : '3',
        subTo : 'about/history',
        subTitle : '회사연혁',
      },
    ],
  },
  { 
    id : 2,
    to : 'competency',
    title: '핵심역량',
    subTitles : [
      {
        subId : '0',
        subTo : 'competency/hygateone',
        subTitle : '클라우드·SaaS',
      },
      {
        subId : '1',
        subTo : 'competency/maintenance',
        subTitle : '유지보수',
      },
      {
        subId : '4',
        subTo : 'competency/process',
        subTitle : '서비스 처리 프로세스',
      },
      {
        subId : '5',
        subTo : 'competency/config',
        subTitle : '형상관리 프로세스',
      },
    ],
  },
  {
    id : 3,
    to : 'product', 
    title: '제품소개',
    subTitles : [
      {
        subId : '0',
        subTo : 'product/hygateone',
        subTitle : 'HyGateOne',
      },
      {
        subId : '1',
        subTo : 'product/scheduler',
        subTitle : '계획 스케줄링',
      },
      {
        subId : '2',
        subTo : 'product/rodcutting',
        subTitle : 'Rod Cutting',
      },
    ],
  },
  { 
    id : 4,
    to : 'recruit', 
    title: '인재채용',
    subTitles : [
      {
        subId : '1',
        subTo : 'recruit',
        subTitle : '채용 계획',
      },
    ],
  },
  { 
    id : 5,
    to : 'support', 
    title: '고객지원',
    subTitles : [
      {
        subId : '1',
        subTo : 'support/notice',
        subTitle : '공지사항',
      },
      {
        subId : '2',
        subTo : 'support/location',
        subTitle : '오시는 길',
      },
      {
        subId : '3',
        subTo : 'support/news',
        subTitle : '회사소식',
      },
      {
        subId : '4',
        subTo : 'support/questions',
        subTitle : '문의사항',
      },
    ],
  },
];
 
const getFooterTitleSlice = createSlice({
  name:'footerTitleSlice',
  initialState: {value : initialStateValue},
  reducers:{
    
    }
});



export default getFooterTitleSlice;